if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.hasAttribute('available')) return;

      this.variantId = this.dataset.variantId;
      this.unavailableHtml = this.querySelector('template').innerHTML;
      
      this.refreshBtn = this.refreshBtnClick.bind(this);

      this.getAvailability(this.dataset.variantId);
    }

    refreshBtnClick() {
      this.getAvailability(this.variantId);
    }

    bindRefreshButton() {
      const refreshBtn = this.querySelector('.btn-refresh');
      if (refreshBtn) {
        refreshBtn.removeEventListener('click', this._refreshHandler);
        this._refreshHandler = () => this.refreshBtnClick();
        refreshBtn.addEventListener('click', this._refreshHandler);
      }
    }

    bindDetailButton() {
      const btnOffcanvas = this.querySelector('.btn-offcanvas');
      if (btnOffcanvas) {
        btnOffcanvas.removeEventListener('click', this._detailHandler);
        this._detailHandler = (e) => this.handleDetailBtn(e.target);
        btnOffcanvas.addEventListener('click', this._detailHandler);
      }
    }

    handleDetailBtn(btn){
      const target = btn.dataset.target;
      if(target){
        const offcanvas = document.querySelector(target);
        if(offcanvas){
          SimpleOffcanvas.toggle(offcanvas);
        }
      }
    }

    async getAvailability(variantId) {
      this.variantId = variantId;
      this.rootUrl = this.dataset.rootUrl || '';
      if (!this.rootUrl.endsWith('/')) this.rootUrl = `${this.rootUrl}/`;
      
      try {
        const response = await fetch(`${this.rootUrl}variants/${variantId}/?section_id=pickup-availability`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();
        this.renderPickupInfo(html);
      } catch (error) {
        console.error(error);
        this.handleAvailabilityError();
      }
    }

    renderPickupInfo(sectionHtml) {
      const existingOffcanvas = document.querySelector('.pickup-offcanvas');
      if (existingOffcanvas) {
        existingOffcanvas.remove();
      }
  
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      
      const pickupStatus = doc.querySelector('.pickup-status');
      
      if (!pickupStatus) {
        this.innerHTML = '';
        this.classList.remove('available');
        return;
      }

      this.classList.add('available');
      this.innerHTML = pickupStatus.outerHTML;

      this.bindDetailButton();
      
      const pickupOffcanvas = doc.querySelector('.pickup-offcanvas');
      if (pickupOffcanvas) {
        document.body.appendChild(pickupOffcanvas);
      }

      this.bindRefreshButton();
    }

    handleAvailabilityError() {
      const refreshBtn = this.querySelector('.btn-refresh');
      if (refreshBtn && this._refreshHandler) {
        refreshBtn.removeEventListener('click', this._refreshHandler);
      }

      this.innerHTML = this.unavailableHtml;

      this.bindRefreshButton();
    }

    updateVariant(variantId) {
      this.getAvailability(variantId);
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}